export const WORKSPACES_DOCS_URL = 'https://beta.sanity.io/docs/platform/studio/config/workspaces'
